<template>
    <div class="row row-xs">
        <div class="col-sm-6 col-lg-3" v-for="card in carditems" :key="card.id">
            <div :class="['card',  'card-body', 'bg-gray-50']">
                <p class="tx-spacing-1 tx-8 tx-color-02 tx-black  mg-b-8">{{ card.name }}</p>
                <div class="d-flex  d-xl-flex align-items-end">
                    <p class="tx-normal  tx-rubik mg-b-0 mg-r-5 lh-1 tx-black">{{ card.number }}</p>
                </div>
            </div>
        </div><!-- col -->
    </div>
</template>

<script>
    export default {
        props: ['carditems'],
        name: "AccordionCard",
    }
</script>

<style scoped>

</style>
